/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ChosenDescription } from './';
import {
    ChosenDescriptionFromJSON,
    ChosenDescriptionFromJSONTyped,
    ChosenDescriptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubmitAdvancedSearchRequest
 */
export interface SubmitAdvancedSearchRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SubmitAdvancedSearchRequest
     */
    fileAttached: boolean;
    /**
     * 
     * @type {ChosenDescription}
     * @memberof SubmitAdvancedSearchRequest
     */
    chosenDescription: ChosenDescription;
}

/**
 * Check if a given object implements the SubmitAdvancedSearchRequest interface.
 */
export function instanceOfSubmitAdvancedSearchRequest(value: object): value is SubmitAdvancedSearchRequest {
    if (!('fileAttached' in value) || value['fileAttached'] === undefined) return false;
    if (!('chosenDescription' in value) || value['chosenDescription'] === undefined) return false;
    return true;
}

export function SubmitAdvancedSearchRequestFromJSON(json: any): SubmitAdvancedSearchRequest {
    return SubmitAdvancedSearchRequestFromJSONTyped(json, false);
}

export function SubmitAdvancedSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitAdvancedSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileAttached': json['fileAttached'],
        'chosenDescription': ChosenDescriptionFromJSON(json['chosenDescription']),
    };
}

export function SubmitAdvancedSearchRequestToJSON(value?: SubmitAdvancedSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileAttached': value['fileAttached'],
        'chosenDescription': ChosenDescriptionToJSON(value['chosenDescription']),
    };
}

